export type AuthDeepLinkFlow = "otp-verification" | "reset-otp";

export interface AuthDeepLinkState {
  flow?: AuthDeepLinkFlow;
  email?: string;
  code?: string;
}

export function getAuthDeepLinkState(
  search?: URLSearchParams,
): AuthDeepLinkState {
  const params =
    search ??
    (typeof window === "undefined"
      ? undefined
      : new URLSearchParams(window.location.search));

  if (!params) {
    return {};
  }

  const flow = params.get("flow");
  const email = params.get("email") ?? undefined;
  const code = params.get("otp") ?? params.get("code") ?? undefined;

  if (!email) {
    return {};
  }

  if (flow === "otp-verification") {
    return { flow, email, code };
  }

  if (flow === "reset-otp") {
    return { flow, email, code };
  }

  return {};
}
